import React from 'react'

const AuthUserContext = React.createContext({
  authUser: null
})

export default AuthUserContext
